import { endpoints } from "../../../config";
import appClient from "../../common/services/AppClient";
import type { UserInfo } from "../types/UserInfo";

class UserInfoService {
    async getUserInfo() {
        const url = `${endpoints.tasksUrl}users/userInfo`;
        const resp = await appClient.get<UserInfo>(url);
        const userInfo = resp.unwrapOr({} as UserInfo);
        return userInfo;
    }
}

const UserService = new UserInfoService();
export default UserService;
